import MugenScroll from 'vue-mugen-scroll'
import Vue from 'vue'

Vue.component('MugenScroll', MugenScroll)
